// @flow

import React from 'react';
import { priceFormat } from '../../helpers';
import withErrorBoundary from '../withErrorBoundary';

type Props = {|
  className?: ?string,
  amount: number,
  decimalDash?: boolean,
  displayZeroes?: boolean,
  displayCurrencySymbol?: boolean,
  displayCurrencyText?: boolean,
  displayPrefix?: boolean,
  postfix?: string,
|};

const Price = ({
  className,
  amount,
  decimalDash,
  displayZeroes,
  displayCurrencySymbol,
  displayCurrencyText,
  displayPrefix,
  postfix,
}: Props) => {
  const price = priceFormat(amount, {
    displayZeroes,
    decimalDash,
    currency: displayCurrencySymbol,
    currencyText: displayCurrencyText,
    prefix: displayPrefix,
  });

  return (
    <span className={className}>
      {price}
      {' '}
      {postfix && postfix}
    </span>
  );
};

Price.defaultProps = {
  className: null,
  displayZeroes: false,
  decimalDash: true,
  displayCurrencySymbol: false,
  displayCurrencyText: false,
  displayPrefix: false,
  postfix: '',
};

export default withErrorBoundary<*, *, Props, *, *>(Price);
